import { render } from "./welcome.vue?vue&type=template&id=7eeba69c&scoped=true"
import script from "./welcome.vue?vue&type=script&lang=js"
export * from "./welcome.vue?vue&type=script&lang=js"

import "./welcome.vue?vue&type=style&index=0&id=7eeba69c&lang=scss&scoped=true"
import "./welcome.vue?vue&type=style&index=1&id=7eeba69c&lang=scss"
script.render = render
script.__scopeId = "data-v-7eeba69c"

export default script